require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-137-use-a-template.json") })
        }
      }, "path---article-137-use-a-template");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-137-use-a-template!./.cache/json/article-137-use-a-template.json
// module id = 489
// module chunks = 231608221292675